import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { useParams } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import ScrollToTopButton from '../../components/ScrollToTopButton';
import LoadingSpinner from '../../components/LoadingSpinner';

// TYPES
import { ChildSafeStandardFetchChildSafeStandard } from '../../api/models/';
import { RouteParams } from '../../Interfaces';

const ChildSafeStandardsDetail: React.FC = () => {
	// Getting the Id from params
	const params = useParams<RouteParams>();
	const childSafeStandardId = params.id;

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	// Initial Data for state
	const initialData: ChildSafeStandardFetchChildSafeStandard = {
		id: undefined,
		title: undefined,
		description: undefined,
		pageContent: ''
	};

	const [childSafetyStandardsDetailData, setChildSafetyStandardsDetailData] =
		React.useState<ChildSafeStandardFetchChildSafeStandard>(initialData);

	const getChildSafetyStandardDetailData = async () => {
		setIsLoading(true);

		const response = await apibridge.getChildSafeStandardsDetailData(childSafeStandardId);

		response.result = response.result || initialData;

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			setChildSafetyStandardsDetailData(response.result);
		}
	};

	React.useEffect(() => {
		getChildSafetyStandardDetailData();
	}, []);

	const { title, description, pageContent } = childSafetyStandardsDetailData;

	const decodedpageContent = decodeURIComponent(pageContent || '');

	return (
		<div className="page-general-layout wide-gap">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<p className="sub-purple-text mbtom-16">Child Safe Standard</p>

								<h1 className="main-page-header">{title}</h1>

								<p className="sub-grey-text mbtom-48">{description}</p>

								<div
									className="decoded-page-content ql-editor"
									dangerouslySetInnerHTML={{ __html: decodedpageContent }}
								/>

								<ScrollToTopButton extraClass="mtop-16" />
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ChildSafeStandardsDetail;
